import { loadable } from '@change-corgi/core-react/loadable';

import type { AppRoute } from '#src/shared/routes';

import { Loading } from '#src/app/shared/routes';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'admin-fcm-bulk-delete',
		path: '/admin/fcm-bulk-delete',
		component: loadable(async () => import(/* webpackChunkName: "pages/admin-fcm-bulkDelete" */ './index'), {
			exportName: 'AdminFcmBulkDelete',
			fallback: Loading,
		}),
		frame: true,
		restrictedAccess: {
			authOnly: true,
			role: 'staffAdmin',
		},
	},
];
